import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

const PrivatePublicRoute = () => {
  const userToken = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  return (
    !userToken ? <Outlet /> : <Navigate to={ role == "Vendor" ? '/dashboard':"/customer-dashboard"} />
  )
}

export default PrivatePublicRoute

